import script from "./edit-qd.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit-qd.vue?vue&type=script&lang=ts&setup=true"

import "./edit-qd.vue?vue&type=style&index=0&id=953a7636&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953a7636"]])

export default __exports__